import * as React from 'react';
import { AScene } from '@eagerlogic/react-mvc';
import { GeneralSettingsModel } from './model/GeneralSettingsModel';
import { GeneralSettingsController } from './controller/GeneralSettingsController';
import { ISceneFactory } from 'scenes/ISceneFactory';
import { HistoryItem } from 'utils/Navigation';
import { Paper } from 'components/paper';
import { LinearProgress, Checkbox, FormControlLabel, Button, Table, TableHead, TableRow, Tab, TableCell, TableBody, Icon } from '@material-ui/core';
import { MessageDialog } from 'components/MessageDialog';
import { EditVacationTypeDialog } from './EditVacationTypeDialog';
import { EditWorkdaysDialog } from './EditWorkdaysDialog';
import { ExtraWorkDaysPaper } from './ExtraWorkDaysPaper';

export class GeneralSettingsScene extends AScene<Props, GeneralSettingsModel, GeneralSettingsController> {

    public constructor(props: Props) {
        super(props);

        this.handleAddVacationTypeClicked = this.handleAddVacationTypeClicked.bind(this);
        this.handleEditVacationTypeClicked = this.handleEditVacationTypeClicked.bind(this);
        this.handleDeleteVacationTypeClicked = this.handleDeleteVacationTypeClicked.bind(this);
        this.handleSureDeleteVacationType = this.handleSureDeleteVacationType.bind(this);
        this.handleCancelDeleteVacationType = this.handleCancelDeleteVacationType.bind(this);
    }

    protected createControlller(): GeneralSettingsController {
        return new GeneralSettingsController();
    }

    private handleAddVacationTypeClicked() {
        this.controller.onAddVacationTypeClicked();
    }

    private handleEditVacationTypeClicked(vtId: string) {
        this.controller.onEditVacationTypeClicked(vtId);
    }

    private handleDeleteVacationTypeClicked(vtId: string) {
        this.controller.onDeleteVacationType(vtId);
    }

    private handleSureDeleteVacationType() {
        this.controller.onSureDeleteVacationType();
    }

    private handleCancelDeleteVacationType() {
        this.controller.onCancelDeleteVacationType();
    }

    public render(): React.ReactNode {
        if (this.model.isInit) {
            return (
                <></>
            );
        }
        return (
            <div style={{ width: '100%', padding: '80px' }}>
                {this.renderVacationTypesPaper()}
                {this.model.deletingVacationId != null && (
                    <MessageDialog
                        message={"Are you sure you want to delete this vacation type?"}
                        okButtonTitle="Yes"
                        cancelButtonTitle="no"
                        onOkButtonClicked={this.handleSureDeleteVacationType}
                        onCancelButtonClicked={this.handleCancelDeleteVacationType}
                    />
                )}
                {this.renderWorkDaysPaper()}

                <ExtraWorkDaysPaper model={this.model.extraWorkDays} controller={this.controller} />
            </div>
        )
    }

    private renderVacationTypesPaper() {
        return (
            <Paper title="Vacation types">
                <Table style={{ width: '100%' }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>Color</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.model.vacationTypes.map((item, index) => {
                            return (
                                <TableRow key={"vtrow-" + index}>
                                    <TableCell>{item.name}</TableCell>
                                    <TableCell>
                                        <div style={{ display: 'inline-block', width: '20px', height: '20px', backgroundColor: item.color }}></div>
                                    </TableCell>
                                    <TableCell align="right" style={{width: '80px'}}>
                                        <Icon style={{ color: '#ca2', margin: '2px', cursor: 'pointer', fontSize: '16px' }} onClick={() => { this.handleEditVacationTypeClicked(item.id) }}>edit</Icon>
                                        {item.id != "VACATION" && (
                                            <Icon style={{ color: '#c32', margin: '2px', cursor: 'pointer', fontSize: '16px' }} onClick={() => { this.handleDeleteVacationTypeClicked(item.id) }}>delete</Icon>
                                        )}

                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>

                <div style={{width: '100%', marginTop: '32px'}}>
                    <Button color="default" variant="contained" onClick={this.handleAddVacationTypeClicked}>Add</Button>
                </div>

                {this.model.editVacationTypeDialogModel != null && (
                    <EditVacationTypeDialog model={this.model.editVacationTypeDialogModel} controller={this.controller}></EditVacationTypeDialog>
                )}
            </Paper>
        )
    }

    private renderWorkDaysPaper() {
        const weekDays: string[] = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        var workDaysStr: string = "";
        var isFirst: boolean = true;
        for (var i = 0; i < this.model.workDays.length; i++) {
            if (!this.model.workDays[i]) {
                continue;
            }
            if (isFirst) {
                isFirst = false;
            } else {
                workDaysStr += ", ";
            }

            workDaysStr += weekDays[i];
        }
        return (
            <Paper title="Work days">
                {workDaysStr}
                <div style={{ marginTop: "32px" }}>
                    <Button variant="contained" color="default" onClick={() => {this.controller.onEditworkdaysClicked()}}>Edit</Button>
                </div>

                {this.model.isEditWorkdaysDialogVisible && (
                    <EditWorkdaysDialog workdays={this.model.workDays} controller={this.controller} />
                )}
                
            </Paper>
        );
    }


}

export class Props {

}

export class GeneralSettingsSceneFactory implements ISceneFactory {

    create(historyItem: HistoryItem): React.ReactNode {
        return (
            <GeneralSettingsScene />
        );
    }

}